import { Dispatch, UnknownAction } from 'redux';
import { get } from '../utils';
import ActivitiesResponse from './domain/ActivitiesResponse';
import CarouselResponse from './domain/CarouselResponse';
import ArticlesResponse from './domain/ArticlesResponse';
import PaKryssResponse from './domain/PaKryssResponse';
import StartPuffsResponse from './domain/StartPuffsResponse';
import StartSponsorsResponse from './domain/StartSponsorsResponse';

export type Loading = 'activities' | 'carousel' | 'articles' | 'pa_kryss' | 'start_puffs' | 'start_sponsors';
export type FrontPageActionType =
  | 'loadActivities'
  | 'loadArticles'
  | 'loadCarousel'
  | 'loadPaKryss'
  | 'loadStartPuffs'
  | 'loadStartSponsors'
  | 'startLoading'
  | 'endLoading';
export interface FrontPageAction extends UnknownAction {
  type: FrontPageActionType;
  activities?: ActivitiesResponse;
  articles?: ArticlesResponse;
  carousel?: CarouselResponse;
  paKryss?: ArticlesResponse;
  startPuffs?: StartPuffsResponse;
  startSponsors?: StartSponsorsResponse;
  startLoad?: Loading;
  endLoad?: Loading;
}

interface Action<T> {
  (response: T): FrontPageAction;
}

const loadArticlesAction: Action<ArticlesResponse> = (articles): FrontPageAction => ({
  type: 'loadArticles',
  articles,
});

const loadActivitiesAction: Action<ActivitiesResponse> = (activities): FrontPageAction => ({
  type: 'loadActivities',
  activities,
});

const loadCarouselAction: Action<CarouselResponse> = (carousel): FrontPageAction => ({
  type: 'loadCarousel',
  carousel,
});

const loadPaKryssAction: Action<ArticlesResponse> = (paKryss): FrontPageAction => ({
  type: 'loadPaKryss',
  paKryss,
});

const loadStartPuffsAction: Action<StartPuffsResponse> = (startPuffs): FrontPageAction => ({
  type: 'loadStartPuffs',
  startPuffs,
});

const loadStartSponsorsAction: Action<StartSponsorsResponse> = (startSponsors): FrontPageAction => ({
  type: 'loadStartSponsors',
  startSponsors,
});

const startLoadingAction = (startLoad: Loading) => ({
  type: 'startLoading',
  startLoad,
});

const endLoadingAction = (endLoad: Loading) => ({
  type: 'endLoading',
  endLoad,
});

const fetch =
  <T>(dispatch: Dispatch, url: string, loading: Loading, action: Action<T>) =>
  (): Promise<void> => {
    dispatch(startLoadingAction(loading));
    return get<T>(url)
      .then((response) => {
        dispatch(action(response));
      })
      .finally(() => {
        dispatch(endLoadingAction(loading));
      });
  };

export const fetchActivities = (dispatch: Dispatch) => fetch(dispatch, '/aktiviteter/api/start', 'activities', loadActivitiesAction);

export const fetchCarousel = (dispatch: Dispatch) => fetch(dispatch, '/startpage/api/carousel', 'carousel', loadCarouselAction);

export const fetchArticles = (dispatch: Dispatch) => fetch(dispatch, '/startpage/api/articles', 'articles', loadArticlesAction);

export const fetchPaKryss = (dispatch: Dispatch) => fetch(dispatch, '/startpage/api/pa-kryss', 'pa_kryss', loadPaKryssAction);

export const fetchStartPuffs = (dispatch: Dispatch) => fetch(dispatch, '/startpage/api/start-puffs', 'start_puffs', loadStartPuffsAction);

export const fetchStartSponsors = (dispatch: Dispatch) => fetch(dispatch, '/startpage/api/start-sponsors', 'start_sponsors', loadStartSponsorsAction);
